import { EventEmitter } from '@angular/core';
// enum companyState{invalid=0,valid}
var ComponentSolidCard = (function () {
    function ComponentSolidCard() {
        this.itemClick = new EventEmitter();
        this.postData = {};
    }
    ComponentSolidCard.prototype.handleItemClick = function (id, type) {
        this.postData.id = id;
        this.postData.type = type;
        this.postData.isCloseWrap = false;
        this.itemClick.emit(this.postData);
    };
    ComponentSolidCard.prototype.ngOnInit = function () { };
    return ComponentSolidCard;
}());
export { ComponentSolidCard };



// WEBPACK FOOTER //
// ./src/component-ui/solid-card/component.ts.pre-build-optimizer.js